<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose" v-loading="loading">
    <div class="dialogData">
        <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-if="resultTpye"/>
      <div class="feedbackDetail" v-for="(item,index) in orderList" :key="index" v-if="!resultTpye">
        <div class="detailHeader">
          <el-avatar class="avatar" :src="item.HeadPortrait"></el-avatar>
          <div class="detailPeople">
            <div class="realPeople">{{item.RealName}} {{memberType!=2?'('+setNumAdd(item)+')':''}} <span class="icon_thumbs" :class="item.AppraisalStatus==1?'up':'down'"></span> <span class="isSeller_tag" :class="item.AppraisalType==1?'buyer':''"  v-if="memberType==2||userInfo.IsSeller">{{item.AppraisalType==1?$t('base.buyer'):$t('base.seller')}}</span></div>
            <div class="detailDate">{{item.CreateDate|setTime}}</div>
          </div>
        </div>
        <p class="detailText">{{item.AppraisalContent}}</p>
      </div>

        <el-scrollbar>
      <div v-if="orderDetail" style="max-height:300px;">
        <div class="goodsDetail" v-for="(item,index) in orderDetail.Commodities">
             <el-image class="like_img" :src="item.TitImg!='没有可上传的图片'?item.TitImg+'?imageView2/2/w/200':'../static/images/noimg.svg'" fit="contain"></el-image>
          <div class="goodsText">
            <p class="line_txt3">{{item.Title}}</p>
            <span class="price"><span>{{areaSymbol}} {{item.USD_Price}}</span></span>
          </div>
        </div>
      </div>
      </el-scrollbar>
    <div slot="footer" class="dialog_footer">
      <el-button type="primary" @click="handleClose">{{ $t('base.done') }}</el-button>
    </div>
    </div>
    </div>
  </el-dialog>
</template>
<script>
import NOTN from "@/components/notnull.vue";
import { getInfo, getTime,numAdd } from "@/api/public";
export default {
  name: '',
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      loading: false,
      resultTpye:false,
      orderList: '',
      orderDetail:''
    }
  },
  props: {
    dialogClass: '',
    title: "",
    domVisible: Boolean,
    list: {},
    memberType:1,//被查看方状态 1买家，2卖家
    viewList: {},
    userInfo: {}
  },
  components: { NOTN},
  watch: {},
  filters: {
    setTime(val) {
      return getTime(val, -8, 4, 'cn')
    },
  },
  mounted() {
    this.getMyFeedback()
  },
  created() {},
  methods: {
    setNumAdd(obj){
      //item.SellFavorableCount+item.BuyFavorableCount
      var num=numAdd(obj.SellFavorableCount,obj.BuyFavorableCount)
      return num
    },
    // 获取信息列表
    getMyFeedback() {
      let that = this
      that.loading = true;
      var QueryMemberid=''
      var userMemberid=this.userInfo.MappingUserId
      if(this.memberType!=2){
        QueryMemberid=this.userInfo.MappingUserId
      }else{
        userMemberid=that.list.memberid?that.list.memberid:this.userInfo.MappingUserId
      }
      let data = { operator_id: this.userInfo.MappingUserId, OrderId: that.list.OrderId, memberid: userMemberid, token: this.userInfo.ChineseToken, pageIndex: 1, pageSize: 60, AppraisalStatus: '', AppraisalType: '', QueryMemberid: QueryMemberid }
      this.$get(this.$interface.GetAppraisalListByOrder, data).then(res => {
        if (res.result != 0) {
          that.orderList = res.data
          that.orderDetail=res.data[0]
          that.loading = false;
          if(res.data.length<=0){
            that.resultTpye=true
          }
        }else{
          that.loading = false;
          that.resultTpye=true
        }
        //console.log(res)
      }).catch(err=>{
          that.loading = false;
          that.resultTpye=true
      })
      //MyNotificationForWeb
    },
    handleClose() {
      this.$emit('closeDialog', 'feedback', false)
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/historylist.css";
.isSeller_tag{
    display: inline-block;
    width: 40px;
    height: 18px;
    border-radius: 2px;
    background: #58A800;
    color: #fff;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    margin-left: 5px;
}
.isSeller_tag.buyer{
    background: #5F6DAE;
}
.icon_thumbs{
  display: inline-block;
  width: 16px;
  height: 18px;
  margin-left: 5px;
  position: relative;
}
.icon_thumbs:before{
  position: absolute;
  content: '';
  background: url(../../../static/images/icon/icon_thumbs_up_blue.svg) no-repeat;
  width: 16px;
  height: 16px;
  top: 0;

}
.icon_thumbs.down:before{
  top: 2px;
  transform:rotateX(180deg);
}
.realPeople{
      display: flex;
    align-items: center;
}
.goodsDetail .like_img{
  margin-right:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/feedback.vue